import React, { useState, useEffect } from 'react';
import api from '../api';
import LoadingSpinner from './LoadingSpinner';
import axios from 'axios';
import './Buses.css';

const Buses = () => {
  const [buses, setBuses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBuses = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const res = await api.get('/buses', {
          headers: {
            'x-auth-token': token,
          },
        });
        setBuses(res.data);
      } catch (err) {
        console.error('Error fetching buses:', err.response.data);
        setError('Failed to load buses data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchBuses();
  }, []);

  return (
    <div className="buses-container">
      <div className="main-content">
        <header className="buses-header">
          <h1>Buses</h1>
        </header>
        
        {error && (
          <div className="error-message">
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}
        
        <div className="buses-list">
          {isLoading ? (
            <LoadingSpinner size="medium" message="Loading buses..." />
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Bus Number</th>
                  <th>Capacity</th>
                  <th>Route</th>
                  <th>Driver</th>
                </tr>
              </thead>
              <tbody>
                {buses.length > 0 ? (
                  buses.map((bus) => (
                    <tr key={bus._id}>
                      <td>{bus.busNumber}</td>
                      <td>{bus.capacity}</td>
                      <td>{bus.route ? bus.route.name : 'N/A'}</td>
                      <td>{bus.driver ? bus.driver.name : 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                      No buses found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Buses;
